import React from 'react';
import { trans, getResourcePath } from '@spotahome/soyuz/client';

import TestimonialQuote from '@spotahome/landings-common/src/components/TestimonialQuote';

import './QuoteSection.scss';

const image = {
  src: getResourcePath(`/images/home/quote-img.jpg`),
  alt: trans('home.tenant.quote')
};

const QuoteSection = () => (
  <section className="quote-section">
    <TestimonialQuote
      theme="pink"
      image={image}
      message={trans('home.tenant.quote')}
      source={trans('home.tenant.quote.source')}
    />
  </section>
);

export default QuoteSection;
